import {makeStyles} from "@material-ui/core";

export default function css() {

    return makeStyles(theme => ({
        root: {
            display: 'flex',
            padding: 10,
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            width: '100%',
            padding: 10,
        },
        imagem: {
            maxWidth: 1000,
            maxHeight: 1000,
            width: '100%',
            height: 900
        },
    }));

}